import {
    DynamicType,
    FieldControlEnum,
    FieldStatusEnum,
    FiltersType,
    OptionsType
} from "@context/map/typeMutableStore";
import treeToHashMap, { AsObjectHashMap } from "@context/map/utilMutableStore";
import logger from "@utils/logger";
import { HashElement } from "@context/map/units/unitsStore";
import { GeoZoneDynamic, MessageTime } from "@baseTypes/baseType";
import { WsChange } from "@api/socket/WebSocketService";
import { actions as GeoZoneSliceActions } from '../../..//store/reducers/geoZones';
import { store } from "../../../store";
const httpClient = require('@infobis/api-module').default;


type metaType = {
    status: FieldStatusEnum
    load: boolean
    error: string
    dynamic: DynamicType
    filters: FiltersType
    lastUpdate: any;
}

const log = logger.getLogger("field.store")

type GeoZoneGeometry = {
    type: 'polygon',
    coordinates: RawPolygonWithHoles
}

export const ZoneTypes = {
    CADASTRE: 'cadastre',
    FIELD : 'field',
    UNUSED: 'unused',
    VIEWONLY: 'viewOnly',
    HOME: 'home',
    OTHER: 'other'
} as const
export type ZoneTypesValues =  typeof ZoneTypes[keyof typeof ZoneTypes]

export interface GeoZoneHashElement extends HashElement {
    operations?: OperationMap
    geometry?: GeoZoneGeometry
    glid: string,
    name: string,
    area: number,
    color: number,
    dynamic?: GeoZoneDynamic,
    manualArea: boolean,
    departmentId: number,
    comment: string,
    zoneType: ZoneTypesValues
}

interface OperationMap extends Record<string, OperationElement> {
}

export type GeoPoint = [lat: number, lon: number];
export type RawPolygon = GeoPoint[]
export type RawHole = RawPolygon
export type RawPolygonWithHoles = [RawPolygon, ...RawHole[]]
interface UnitInfoElement {
    area: number
    avgSpeed: number
    distance: number
    duration: number
    endTime: MessageTime
    startTime: MessageTime
}

export interface OperationElement {
    area: number
    areaCultivated: number
    avgSpeed: number
    coordinates: RawPolygonWithHoles[]
    distance: number
    endTime: MessageTime
    operationId: number
    startTime: MessageTime
    unitInfo: {
        [k: number]: UnitInfoElement
    }
}
class FieldsStore {
    type = FieldControlEnum.FIELDS
    fields: any = {}
    fieldType: any = []
    hashFields: AsObjectHashMap<GeoZoneHashElement> = {}

    options: OptionsType = {
        zIndex: 10
    }

    meta: metaType = {
        status: FieldStatusEnum.NO_TOUCH,
        load: false,
        error: "",
        dynamic: [],
        filters: [],
        lastUpdate: new Date().getTime()
    }

    doSubscribe: (a: any) => void = (a: any) => ""

    constructor() {
        //@ts-ignore
        window.FieldService = this

        this.setLastUpdate = this.setLastUpdate.bind(this)
        this.reduce = this.reduce.bind(this)
        this.fetchDynamicDataField = this.fetchDynamicDataField.bind(this)
        this.setFilters = this.setFilters.bind(this)
    }

    public async init() {
        log.debug("Initializing fields service")
        await Promise.all([this.fetchFields(), this.fetchFieldsType()])
        this.setLastUpdate()
    }

    setLastUpdate = () => {
        this.meta.lastUpdate = new Date().getTime();
        this.doSubscribe(Object.assign({}, this.meta))
    }

    subscribe(func: any) {
        this.doSubscribe = func
    }

    reduce(type: FieldControlEnum, changes: WsChange[]) {
        switch (type) {
            case FieldControlEnum.FIELDS:
                this.fields = changes
                this.hashFields = treeToHashMap(changes);
                this.changeStatus(FieldStatusEnum.GET_FIELDS)
                break;
            case FieldControlEnum.TYPE:
                this.fieldType = changes
                break;
            case FieldControlEnum.DYNAMIC:
                store.dispatch(GeoZoneSliceActions.applyWsChange({ changes }))
                this.changeStatus(FieldStatusEnum.GET_DYNAMIC)
                break;
        }
        this.setLastUpdate()
    }

    setFilters(props: any) {
        let { value, action } = props

        switch (action) {
            case "ADD": {
                this.meta.filters.push(value)
                break;
            }
            case "REMOVE": {
                this.meta.filters = this.meta.filters.splice(value)
                break;
            }
        }

        this.changeStatus(FieldStatusEnum.SET_FILTERS)
        this.setLastUpdate()
    }

    changeStatus(type: FieldStatusEnum) {
        this.meta.status = type
    }

    fetchDynamicDataField(data: any) {
        this.reduce(FieldControlEnum.DYNAMIC, data)
    }

    //=============================================>
    async fetchFields() {
        try {
            this.meta.load = true
            let result = await httpClient.makeRequest({
                url: `/fieldTree?_ds=1638266027802&loadDate=2021-11-24T08:15:26.732Z`,
                params: {
                    method: 'GET',
                },
                authorize: true
            })
            this.reduce(FieldControlEnum.FIELDS, result);
        } catch (e) {
            this.meta.error = JSON.stringify(`FIELD: ${e}`);
        } finally {
            this.meta.load = false
        }
    }

    async fetchFieldsType() {
        try {
            this.meta.load = true
            let result = await httpClient.makeRequest({
                url: `/fieldFilterItems?_dc=1650031040963&page=1&start=0&limit=25`,
                params: {
                    method: 'GET',
                },
                authorize: true
            })
            this.reduce(FieldControlEnum.TYPE, result);
        } catch (e) {
            this.meta.error = JSON.stringify(`TYPE: ${e}`);
        } finally {
            this.meta.load = false
        }
    }

}

export default new FieldsStore();